import Handler from "./handler";
import { getQuery, sliceObject } from "../xes-lib";
import bindAll from "lodash.bindall";
import http from "../../../http";

class ConfigureHandler extends Handler {
  init(state, dispatch) {
    window.openProjectByID = () => {}
  }
  save(params) {
    return http.saveBackgroundProject(params)
  }
  getProjectData() {
    let id = getQuery("pid",window.defaultPid)
    let from = getQuery("from",'id')
    if(from == 'xml'){
      return new Promise((resolve, reject) => {
        return reject();
      });
    }
    return http.getProjectById(id)
  }
  createNew(code) {
    if (code && code.indexOf('种类数量') !== -1) {
      window.location.replace('https://code.xesv5.com/scratchmb/?env=configuretopic&pid=5')
    } else {
      window.location.replace('https://code.xesv5.com/scratchmb/?env=configuretopic&pid=6')
    }
  }
  saveAs (params) {
    return http.saveAsTeacherWork(params)
  }
  static getInstance() {
    if (ConfigureHandler.instance === null) {
      ConfigureHandler.instance = new ConfigureHandler()
    }
    return ConfigureHandler.instance
  }
}
ConfigureHandler.instance = null

export default ConfigureHandler